import { DynamicPricingRuleData } from './dynamic-pricing-rule-data';

export interface DynamicPricingScheduleChangedData {
  valid: boolean;
  error: string;
  pricingRule?: DynamicPricingRuleData;
}
